/* eslint-disable */
/**
 * Available rules options:
 *
 * Bool     required
 * Bool     numbers_only
 * Number   min_text_length
 * Number   max_text_length
 * Bool     email
 */
 export default {

    methods: {

      validateInput(form) {
        let errorCounter = 0;
        //recursion for nested form obj
        for (const obj of form) {
          if (typeof obj.value === 'object'
            && obj.value !== null
            && !(typeof obj.value.getMonth === 'function')){
            this.validateInput(obj);
          }

        // prioritize if conditions by importance
        if (obj.validators.required && !obj.value) {
          ++errorCounter;
        }

        if (typeof obj.validators.numbers_only !== 'undefined' && obj.validators.numbers_only) {
          const pattern = /^\d+$/;
          const number = pattern.test(obj.value);
          if (!number) {
            ++errorCounter;
          }
        }

        if (typeof obj.validators.min_text_length !== 'undefined' && obj.value.length < obj.validators.min_text_length) {
          ++errorCounter;
        }

        if (typeof obj.validators.max_text_length !== 'undefined' && obj.value.length > obj.validators.max_text_length) {
          ++errorCounter;
        }

        if (typeof obj.validators.email !== 'undefined' && obj.validators.email) {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const valid = pattern.test(obj.value)
          if (!valid) {
            ++errorCounter;
          }
        }

        if (typeof obj.validators.password !== 'undefined' && obj.validators.password) {
          const pattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/
          const valid = pattern.test(obj.value)
          if (!valid) {
            ++errorCounter;
          }
        }
      }
      // console.log(form)
      return !!errorCounter
    }
    }
  }
